import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

// Currency codes supported by the application
const CURRENCIES = ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'DKK', '000'] as const

interface CurrencySelectorProps {
  value?: string
  onValueChange: (value: string) => void
  disabled?: boolean
  className?: string
  id?: string
  /** Hide the '000' (Other/Multiple) option — not a valid "main" currency (can't convert/format). */
  hideOther?: boolean
}

// Currency symbols for visual identification
const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: 'C$',
  AUD: 'A$',
  DKK: 'kr',
  '000': '¤', // Generic currency symbol
}

const CURRENCY_NAMES: Record<string, string> = {
  USD: 'US Dollar',
  EUR: 'Euro',
  GBP: 'British Pound',
  CAD: 'Canadian Dollar',
  AUD: 'Australian Dollar',
  DKK: 'Danish Krone',
  '000': 'Other/Multiple',
}

export function CurrencySelector({
  value,
  onValueChange,
  disabled = false,
  className,
  id,
  hideOther = false,
}: CurrencySelectorProps) {
  const options = hideOther ? CURRENCIES.filter((c) => c !== '000') : CURRENCIES
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger id={id} className={className} aria-label="Select currency">
        <SelectValue placeholder="Select currency" />
      </SelectTrigger>
      <SelectContent>
        {options.map((code) => (
          <SelectItem key={code} value={code} aria-label={`${CURRENCY_NAMES[code]} (${code})`}>
            <span className="flex items-center gap-2">
              <span className="font-semibold w-6">{CURRENCY_SYMBOLS[code]}</span>
              <span>{code}</span>
              <span className="text-muted-foreground text-xs">- {CURRENCY_NAMES[code]}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
